import Modernisierung from '@/js/modernisierung';
import { objektbesichtigung } from '@/js/validation';
import productModule from '@/store/modules/produkt';

const defaultAllgemeineAngaben = () => {
  return {
    ermittlungsstichtag: undefined,
    baujahr: undefined,
    kernsanierung: false,
    jahrDerKernsanierung: undefined,
    wohnungsnummer: undefined,
    anzahlWohneinheiten: undefined,
    anzahlNutzeinheiten: undefined,
    wohnflaeche: undefined,
    nutzflaeche: undefined,
    valid() {
      return objektbesichtigung.allgemeineAngabenObjektbesichtigung({ ...this, objektart:productModule.getters.objektart() });
    },
  };
};

const allgemeineAngaben = defaultAllgemeineAngaben();

const defaultModernisierungen = () => {
  return {
    valid() {
      return objektbesichtigung.modernisierungenObjektbesichtigung({ aussenwaende, dach, fenster, fussboeden, innenwaende, decken, sanitaer, heizung, technischeAusstattung }, { ...allgemeineAngaben });
    },
  };
}

const modernisierungen = defaultModernisierungen();

const defaultAussenwaende = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
  };
};

const aussenwaende = defaultAussenwaende();

const defaultDach = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.dachObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const dach = defaultDach();

const defaultFenster = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.fensterObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const fenster = defaultFenster();

const defaultFussboeden = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.fussboedenObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const fussboeden = defaultFussboeden();

const defaultInnenwaende = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.innenwaendeObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const innenwaende = defaultInnenwaende();

const defaultDecken = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.deckenObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const decken = defaultDecken();

const defaultSanitaer = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.sanitaerObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const sanitaer = defaultSanitaer();

const defaultHeizung = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.heizungObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const heizung = defaultHeizung();

const defaultTechnischeAusstattung = () => {
  return {
    modernisierung: Modernisierung.KEINE.value,
    jahrDerModernisierung: undefined,
    erlaeuterung: undefined,
    valid() {
      return objektbesichtigung.technischeAusstattungObjektbesichtigung({ ...this }, { ...allgemeineAngaben });
    },
  };
};

const technischeAusstattung = defaultTechnischeAusstattung();

const defaultObjektunterlagen = () => {
  return {
    grundriss: undefined,
    zusatzdokumentGrundriss: undefined,
    energieausweis: undefined,
    zusatzdokumentEnergieausweis: undefined,
    valid() {
      return objektbesichtigung.objektunterlagenObjektbesichtigung({ ...this });
    },
  };
};

const objektunterlagen = defaultObjektunterlagen();

const defaultAnsprechpartner = () => {
  let vname = window.sessionStorage.getItem('vname');
  let nname = window.sessionStorage.getItem('nname');
  return {
    nachname: nname ? nname : undefined,
    vorname: vname ? vname : undefined,
    telefon: undefined,
    erlaeuterung: undefined,
    altName: undefined,
    altFunktion: 'Bitte wählen',
    altTelefon: undefined,
    altEmail: undefined,
    valid() {
      return objektbesichtigung.ansprechpartner({ ...this });
    },
  };
};

const ansprechpartner = defaultAnsprechpartner();

const defaultRechnungData = () => {
  return {
    name1: undefined,
    name2: undefined,
    plz: undefined,
    ort: undefined,
    str: undefined,
    hnr: undefined,
    valid() {
      return objektbesichtigung.defaultRechnung({ ...this });
    },
  }
}

const defaultRechnung = defaultRechnungData();

const defaultAlternativeRechnung = () => {
  return {
    name1: undefined,
    name2: undefined,
    plz: undefined,
    ort: undefined,
    str: undefined,
    hnr: undefined,
    useDefault: true,
    valid() {
      return objektbesichtigung.alternativeRechnung({ ...this });
    }
  }
}

const alternativeRechnung = defaultAlternativeRechnung();

let ausSpeicherGeladen = false;

export const defaultState = () => {
  Object.assign(allgemeineAngaben, defaultAllgemeineAngaben());
  Object.assign(aussenwaende, defaultAussenwaende());
  Object.assign(dach, defaultDach());
  Object.assign(fenster, defaultFenster());
  Object.assign(fussboeden, defaultFussboeden());
  Object.assign(innenwaende, defaultInnenwaende());
  Object.assign(decken, defaultDecken());
  Object.assign(sanitaer, defaultSanitaer());
  Object.assign(heizung, defaultHeizung());
  Object.assign(technischeAusstattung, defaultTechnischeAusstattung());
  Object.assign(modernisierungen, defaultModernisierungen());
  Object.assign(objektunterlagen, defaultObjektunterlagen());
  Object.assign(ansprechpartner, defaultAnsprechpartner());
  Object.assign(defaultRechnung, defaultRechnungData());
  Object.assign(alternativeRechnung, defaultAlternativeRechnung());
  ausSpeicherGeladen = false;
  return {
    allgemeineAngaben,
    aussenwaende,
    dach,
    fenster,
    fussboeden,
    innenwaende,
    decken,
    sanitaer,
    heizung,
    technischeAusstattung,
    modernisierungen,
    objektunterlagen,
    ansprechpartner,
    ausSpeicherGeladen,
    defaultRechnung,
    alternativeRechnung
  };
};
const state = defaultState();

export default state;
